import Box from "@mui/material/Box";
import { LOGO_SIZE } from "./NavbarConstants";
import React from "react";
import { useNavigate } from "react-router-dom";

export const Logo: React.FC<{ isScrolled: boolean }> = ({ isScrolled }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/'); 
  };

  return (
    <Box
      onClick={handleLogoClick}
      sx={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
    >
      <Box
        component="img"
        src={"/images/logo/logo.jpg"}
        alt="MOUCHI"
        sx={{
          height: isScrolled ? LOGO_SIZE.scrolled : LOGO_SIZE.normal,
          width: 'auto',
          objectFit: 'contain',
          transition: 'height 0.3s ease-in-out',
        }}
      />
    </Box>
  );
};














